import { VoucherPrintOrgHeading, VoucherPrintOrgAddress, VoucherPrintDepartmentFooter } from "./VoucherPrintOrgHeader";
import PrintCommon from "app/common/Component/Print/PrintCommon";
import {
  VOUCHER_INVOICE_TYPE,
  VOUCHER_INVOICE_TYPE_VALUE,
} from "app/common/LocalConst";
import { formatMoney, formatPrintPatientCodeSuffix, getDateTime, hideMiddleDigits } from "app/common/LocalFunction";
import React, { memo } from "react";
import QrSurveySection from "app/common/Component/Print/QrSurveySection";

const PrintFormA5 = ({
  componentRef,
  dataVoucherFee,
  initialPatient,
  staffRevenues,
}) => {
  const namesText = staffRevenues
    ?.map((item) => item?.staff?.staffName)
    .join(" ; ");

  return (
    <>
      <PrintCommon
        ref={componentRef}
        marginPage="8mm"
        hidden={false}
        size="A5"
        orientation={"landscape"}
      >
        <header className="printHeader w-100 flex justify-between print-voucher">
          <table className="table-layout-fixed">
            <div className="wraper-print">
              <div className="container-print">
                <VoucherPrintOrgHeading department={dataVoucherFee?.department} withDepartmentName />
                <VoucherPrintOrgAddress department={dataVoucherFee?.department} phonePrefix="Điện Thoại: " />
                <div className="mt-5 text-center">
                  <h4 style={{ fontWeight: "bold", fontSize: "16px" }}>
                    HÓA ĐƠN BÁN HÀNG
                  </h4>
                </div>
              </div>
            </div>
          </table>
        </header>
        <div className="cards-container flex justify-center">
          <div className="container-print-A5">
            <table
              border="0"
              cellPadding="1"
              cellSpacing="0"
              style={{
                width: "100%",
                fontFamily: "Arial, sans-serif",
                fontSize: "14px",
                borderSpacing: "0px 4px",
              }}
            >
              {/* HĐ: HD90980980 (14/07/2025 18:00)  KH: Bùi Đình Minh - 0999888987 */}
              <tbody>
                <tr>
                  <td style={{ width: "50%" }}>
                    Số hóa đơn:{" "}
                    <b>
                      {dataVoucherFee?.code || "Chưa có mã"}{" "}
                      {getDateTime(dataVoucherFee?.voucherDate)}
                    </b>
                  </td>
                  <td style={{ width: "50%" }}>
                    Khách hàng:{" "}
                    <b>
                      {dataVoucherFee?.patient?.displayName || ""}{" "}
                      {formatPrintPatientCodeSuffix(dataVoucherFee?.patient, initialPatient)}
                      {dataVoucherFee?.patient?.phoneNumber
                        ? ` - ${hideMiddleDigits(dataVoucherFee?.patient?.phoneNumber)} `
                        : ""}
                    </b>
                  </td>
                </tr>
                <tr>
                  {console.log("dataVoucherFee", dataVoucherFee)}
                  <td>
                    Nhân viên:{" "}
                    {dataVoucherFee?.accountant?.staffName
                      ? `${dataVoucherFee?.accountant?.staffName} ${dataVoucherFee?.accountant?.position
                        ? `(${dataVoucherFee?.accountant?.position?.name})`
                        : ""
                      } `
                      : "Không rõ"}
                  </td>
                  <td>
                    <td>Tư vấn: {namesText}</td>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="table-responsive">
              <table className="service-table">
                <thead>
                  <tr>
                    <th>STT</th>
                    <th>TÊN HÀNG</th>
                    <th>ĐƠN VỊ</th>
                    <th>SL</th>
                    <th>ĐƠN GIÁ</th>
                    <th>KHUYẾN MÃI</th>
                    <th>THÀNH TIỀN</th>
                  </tr>
                </thead>
                <tbody>
                  {dataVoucherFee?.items?.length > 0 ? (
                    dataVoucherFee?.items?.map((it, index) => (
                      <React.Fragment key={it.id || index}>
                        <tr>
                          <td>{index + 1}</td>
                          <td>
                            {it?.invoiceItem?.invoiceItemRegisterName
                              ? it?.invoiceItem?.invoiceItemRegisterName
                              : it?.invoiceItem?.invoiceItemName}
                          </td>
                          <td></td>
                          <td>{it?.invoiceItem?.quantity}</td>
                          <td>{formatMoney(it?.invoiceItem?.currentFee)}</td>
                          <td>
                            {formatMoney(
                              it?.invoiceItem?.discount +
                              it?.invoiceItem?.allocateDiscount || 0
                            )}
                          </td>
                          <td>
                            {formatMoney(
                              it?.invoiceItem?.subAmountActuallyPaid || 0
                            )}
                          </td>
                        </tr>
                        {it?.treatmentPlanCard && (
                          <>
                            {/* Dịch vụ trong liệu trình */}
                            {Array.isArray(
                              it.treatmentPlanCard.paServiceRegister
                            ) &&
                              it.treatmentPlanCard.paServiceRegister.map(
                                (srv, i) => (
                                  <tr key={`srv-${srv.id || i}`}>
                                    <td></td>
                                    <td
                                      colSpan={8}
                                      style={{
                                        paddingLeft: "20px",
                                        fontStyle: "italic",
                                        fontSize: "0.6rem",
                                      }}
                                    >
                                      (SL: {srv?.quantity || 1}){" "}
                                      {srv?.service?.name || "Dịch vụ không rõ"}
                                    </td>
                                  </tr>
                                )
                              )}

                            {/* Thuốc trong liệu trình */}
                            {Array.isArray(it.treatmentPlanCard.drugs) &&
                              it.treatmentPlanCard.drugs.map((drug, j) => (
                                <tr key={`drug-${drug.id || j}`}>
                                  <td></td>
                                  <td
                                    colSpan={8}
                                    style={{
                                      paddingLeft: "20px",
                                      fontStyle: "italic",
                                      fontSize: "0.6rem",
                                    }}
                                  >
                                    (SL: {drug?.quantity || 1}){" "}
                                    {drug?.drug?.name || "Sản phẩm không rõ"}
                                  </td>
                                </tr>
                              ))}
                          </>
                        )}
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4}>Không có dữ liệu</td>
                    </tr>
                  )}
                </tbody>
                <tfoot style={{ border: "1px solid #ccc" }}>
                  <tr>
                    <td
                      colSpan={3}
                      rowSpan={4}
                      style={{
                        verticalAlign: "top",
                        border: "none",
                        paddingTop: 4,
                      }}
                    >
                      <b>Ghi chú:</b>
                      {dataVoucherFee?.note || "Không có ghi chú"}
                    </td>
                    <td
                      colSpan={3}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      <b>Tổng tiền (VNĐ):</b>
                    </td>
                    <td
                      colSpan={2}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      {formatMoney(dataVoucherFee?.actuallyTotalAmount)}
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan={3}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      <b>Khách Hàng Trả:</b>
                    </td>
                    <td
                      colSpan={2}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      {formatMoney(dataVoucherFee?.customerPaidAmount)}
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan={3}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      <b>Đã Thanh Toán:</b>
                    </td>
                    <td
                      colSpan={2}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      {formatMoney(dataVoucherFee?.amountPaid)}
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan={3}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      <b>Còn nợ:</b>
                    </td>
                    <td
                      colSpan={2}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      {formatMoney(dataVoucherFee?.remainingDebt)}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <div
                style={{
                  textAlign: "center",
                  fontSize: "0.75rem",
                  textTransform: "uppercase",
                }}
              >
                <i>
                  Quý Khách Vui Lòng Kiểm Tra Lại Hàng Và Tiền Trước Khi Rời
                  Khỏi Quầy, Sản Phẩm Đã Mua Vui Lòng Không Đổi trả Không Hoàn
                  Tiền Lại Tiền Khi Khách Hàng Tự Ý Ngưng Dịch Vụ, Sẽ Chuyển
                  Sang lấy Sản Phẩm Hoặc Dịch Vụ Khác.Xin Cảm Ơn Và Hẹn Gặp Lại!
                </i>
              </div>
              <div className="mt-2">
                <span style={{ fontSize: "0.8rem" }}>Cảm ơn quý khách!</span>
              </div>
              <QrSurveySection
                patient={dataVoucherFee?.patient}
              />

            </div>
          </div>
        </div>
      </PrintCommon>
    </>
  );
};

export default memo(PrintFormA5);
